import React, { useEffect } from "react";

const FPSMeter = () => {
  const [fps, setFPS] = React.useState(0);
  const [dot, setDot] = React.useState(false);

  useEffect(() => {
    const getFPS = () =>
      new Promise<number>((resolve) =>
        requestAnimationFrame((t1) =>
          requestAnimationFrame((t2) => resolve(1000 / (t2 - t1)))
        )
      );

    const interval = setInterval(() => {
      getFPS().then((f) => {
        setFPS(f);
        setDot((dot) => !dot);
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
      }}
    >
      <div
        style={{
          width: "12px",
          height: "12px",
          borderRadius: "12px",
          backgroundColor: dot
            ? "hsl(from var(--primary) h s 30 / 100%)"
            : "white",
        }}
      ></div>
      <div style={{ fontSize: "32px" }}>
        {fps.toFixed(3)}
        <span style={{ fontSize: "16px" }}>fps</span>
      </div>
    </div>
  );
};

export default FPSMeter;
